import React from 'react';
import { ZapIcon, CreditCardIcon, InfinityIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { ToothIcon } from '../ToothIcon';
import { images } from '../../data/site';
const trust = [{
  icon: ZapIcon,
  label: 'Instant Digital Access'
}, {
  icon: CreditCardIcon,
  label: 'One-Time Payment'
}, {
  icon: InfinityIcon,
  label: 'Lifetime Access'
}, {
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-navy-950 text-white" data-id="element-165" data-mp="qvdv90k0zv1j">
      <div className="border-b border-white/10 bg-navy-900" data-id="element-166" data-mp="qt9jjwfvxrqp">
        <div className="mx-auto flex max-w-6xl flex-col items-center gap-1 px-4 py-3 text-center" data-id="element-167" data-mp="vmvw7om1tvmi">
          <p className="flex items-center gap-2 font-display text-sm font-extrabold tracking-[0.2em] text-gold-300" data-id="element-168" data-mp="10kxe467qnowe">
            <ToothIcon className="h-5 w-5" data-id="element-169" data-mp="15ifdp5zv8rrq" /> DR. SARAH COLLINS
          </p>
          <p className="text-[10px] font-semibold tracking-[0.15em] text-white/60 sm:text-xs" data-id="element-170" data-mp="1akef4ac1pem1">DIGITAL SMILE DESIGN • CLINICAL PLANNING • AESTHETIC DENTISTRY</p>
        </div>
      </div>

      <div className="mx-auto grid max-w-6xl gap-8 px-4 pb-14 pt-8 lg:grid-cols-[1.05fr_1fr] lg:items-center lg:gap-12 lg:pb-20 lg:pt-14" data-id="element-171" data-mp="4nogbz3kt8mx">
        <div className="text-center lg:text-left" data-id="element-172" data-mp="3vx3q95wzxtb9">
          <p className="font-display text-2xl font-black tracking-tight text-gold-400 sm:text-3xl" data-id="element-173" data-mp="3ru78tij7038w">SMILE DESIGN ROADMAP™</p>
          <h1 className="mt-4 font-display text-[1.9rem] font-black leading-[1.12] tracking-tight sm:text-5xl lg:text-[3.1rem]" data-id="element-174" data-mp="sdsmad48lkh3">
            Stop Guessing Your Smile Designs.{' '}
            <span className="text-gold-300" data-id="element-175" data-mp="infsrveg2gyt">Follow a Clear Clinical Roadmap</span> From Facial Analysis to the Final Aesthetic Plan.
          </h1>
          <p className="mt-5 text-base leading-relaxed text-white/80 sm:text-lg" data-id="element-176" data-mp="el2wrypi1xf8">
            Discover a practical, visual approach to digital smile design that helps you evaluate facial proportions, analyze dental aesthetics, plan restorative cases, and communicate your treatment vision with greater clarity and confidence.
          </p>
        </div>

        <div className="lg:row-span-2" data-id="element-177" data-mp="35jz074vqqscx">
          <img src={images.mockup} alt="Smile Design Roadmap: 6 clinical volumes and 5 bonus resources" className="mx-auto w-full max-w-[560px]" data-id="element-178" data-mp="35muvelg7f2xo" />
        </div>

        <div className="text-center lg:text-left" data-id="element-179" data-mp="2vtw611cvv8d0">
          <p className="mx-auto max-w-xl text-[15px] leading-relaxed text-white/75 lg:mx-0" data-id="element-180" data-mp="2hvfqqm0yg9j9">
            Learn how to organize your smile design workflow, avoid common planning mistakes, and make more informed aesthetic decisions—starting with your next case.
          </p>
          <p className="mx-auto mt-5 max-w-xl rounded-xl bg-gold-400 px-4 py-3 text-center font-display text-sm font-extrabold text-navy-950 sm:text-base lg:mx-0" data-id="element-181" data-mp="27zco7f26y8vs">
            6 Clinical Volumes + 5 Exclusive Professional Bonuses
          </p>
          <div className="mt-5" data-id="element-182" data-mp="b5hukn1pqsaw">
            <CTAButton id="first-cta" label="Yes! I want the Smile Design Roadmap™" sublabel="Complete library + 5 bonuses for only $27" className="lg:mx-0" data-id="element-183" data-mp="b4g87mf8yjdv" />
          </div>
          <ul className="mx-auto mt-5 grid max-w-xl grid-cols-2 gap-x-3 gap-y-2.5 text-left lg:mx-0" data-id="element-184" data-mp="1qop9gxf1yg5o">
            {trust.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2 text-[13px] font-semibold text-white/85 sm:text-sm" data-id="element-185" data-mp="25en33svr3y29">
                <Icon className="h-4 w-4 shrink-0 text-gold-400" aria-hidden="true" data-id="element-186" data-mp="2ed8g78igekvn" />
                {label}
              </li>)}
          </ul>
        </div>
      </div>
    </header>;
}